// Compare Models Product Dropdown (Treadmills & Bikes)
let compareModelsInitialized = false;

function initializeCompareModels() {
  if (compareModelsInitialized) return;
  
  const comparisonDropdowns = document.querySelectorAll('.compare-models-dropdown');
  if (comparisonDropdowns.length === 0) return;
  
  // Initialize dropdowns
  comparisonDropdowns.forEach(dropdown => {
    initializeComparisonDropdown(dropdown);
  });
  
  // Restore dropdown state only for browser navigation (not refresh)
  restoreDropdownState();
  
  compareModelsInitialized = true;
}

// Multiple initialization points to handle DOM manipulation
document.addEventListener('DOMContentLoaded', initializeCompareModels);

// Observer for dynamic content changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      const addedNodes = Array.from(mutation.addedNodes);
      const hasComparisonElements = addedNodes.some(node => 
        node.nodeType === 1 && (
          node.classList?.contains('compare-models-dropdown') ||
          node.querySelector?.('.compare-models-dropdown')
        )
      );
      
      if (hasComparisonElements) {
        setTimeout(initializeCompareModels, 100);
      }
    }
  });
});

// Start observing if we're on a page that might have comparison dropdowns
if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
}

function initializeComparisonDropdown(dropdown) {
  // Skip if already initialized
  if (dropdown.hasAttribute('data-initialized')) {
    return;
  }
  
  const button = dropdown.querySelector('.dropdown-button');
  const panel = dropdown.querySelector('.dropdown-panel');
  const input = dropdown.querySelector('.dropdown-input');
  const buttonText = dropdown.querySelector('.dropdown-button-text');
  const columnId = dropdown.dataset.columnId;

  if (!button || !panel || !buttonText) {
    return;
  }
  
  // Mark as initialized
  dropdown.setAttribute('data-initialized', 'true');

  // Toggle dropdown on button click
  button.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    
    // Close all other comparison dropdowns
    document.querySelectorAll('.compare-models-dropdown').forEach(otherDropdown => {
      if (otherDropdown !== dropdown) {
        const otherButton = otherDropdown.querySelector('.dropdown-button');
        const otherPanel = otherDropdown.querySelector('.dropdown-panel');
        if (otherButton && otherPanel) {
          otherButton.setAttribute('aria-expanded', 'false');
          otherPanel.classList.remove('show');
          otherDropdown.classList.remove('dropdown-open');
        }
      }
    });
    
    // Toggle current dropdown
    if (isOpen) {
      button.setAttribute('aria-expanded', 'false');
      panel.classList.remove('show');
      dropdown.classList.remove('dropdown-open');
    } else {
      button.setAttribute('aria-expanded', 'true');
      panel.classList.add('show');
      dropdown.classList.add('dropdown-open');
    }
  });

  // Handle option selection
  panel.addEventListener('click', function(e) {
    if (e.target.classList.contains('dropdown-option')) {
      e.preventDefault();
      e.stopPropagation();
      
      // Update UI
      const allOptions = dropdown.querySelectorAll('.dropdown-option');
      allOptions.forEach(opt => opt.classList.remove('dropdown-option--selected'));
      e.target.classList.add('dropdown-option--selected');
      
      buttonText.textContent = e.target.textContent.trim();
      if (input) input.value = e.target.dataset.value;
      
      // Close dropdown
      button.setAttribute('aria-expanded', 'false');
      panel.classList.remove('show');
      dropdown.classList.remove('dropdown-open');
      
      // Update comparison content
      updateProductComparison(e.target, columnId);
    }
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target)) {
      button.setAttribute('aria-expanded', 'false');
      panel.classList.remove('show');
      dropdown.classList.remove('dropdown-open');
    }
  });

  // Initialize with selected option if exists
  const selectedOption = dropdown.querySelector('.dropdown-option--selected');
  if (selectedOption) {
    buttonText.textContent = selectedOption.textContent.trim();
    if (input) input.value = selectedOption.dataset.value;
    updateProductComparison(selectedOption, columnId);
  }
}

function updateProductComparison(optionElement, columnId) {
  const productHandle = optionElement.dataset.value;
  const contentContainer = document.getElementById(`comparison-content-${columnId}`);
  
  if (!contentContainer) return;
  
  const comparisonCard = contentContainer.closest('.compare-models-card');
  
  // Handle empty selection
  if (!productHandle) {
    const existingTitle = contentContainer.querySelector('.product-title');
    const existingTextContainer = contentContainer.querySelector('.compare-models-card__text') || contentContainer;
    
    if (existingTitle) {
      existingTitle.textContent = 'Select a product to compare';
    }
    if (existingTextContainer && existingTextContainer !== contentContainer) {
      existingTextContainer.innerHTML = '<p>Select a product to compare specifications</p>';
    }
    return;
  }
  
  // Update product image
  const imageContainer = comparisonCard.querySelector('.compare-models-card__image img');
  
  if (imageContainer && optionElement.dataset.image && optionElement.dataset.image !== 'null' && optionElement.dataset.image !== '') {
    imageContainer.src = optionElement.dataset.image;
    imageContainer.alt = optionElement.textContent.trim();
    
    const newSrc = optionElement.dataset.image;
    const baseUrl = newSrc.split('?')[0];
    imageContainer.srcset = `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=535 535w, ${baseUrl}?width=750 750w, ${baseUrl}?width=940 940w, ${baseUrl}?width=1100 1100w`;
  }
  
  // Update button link
  const buttonElement = comparisonCard.querySelector('.btn');
  if (buttonElement && optionElement.dataset.productUrl) {
    buttonElement.href = optionElement.dataset.productUrl;
  }
  
  // Update price display
  updateProductPrice(comparisonCard, optionElement);
  
  // Get or create title element
  let titleElement = contentContainer.querySelector('.product-title');
  if (!titleElement) {
    const titleWrapper = document.createElement('h3');
    titleWrapper.className = 'compare-models-card__title';
    titleWrapper.innerHTML = '<span class="product-title"></span>';
    contentContainer.insertBefore(titleWrapper, contentContainer.firstChild);
    titleElement = titleWrapper.querySelector('.product-title');
  }
  
  // Get or create text container
  let textContainer = contentContainer.querySelector('.compare-models-card__text');
  if (!textContainer) {
    textContainer = document.createElement('div');
    textContainer.className = 'compare-models-card__text rich-text__text rte';
    contentContainer.appendChild(textContainer);
  }
  
  // Use preloaded product data if available
  const productData = window.productComparisonData?.[productHandle];
  
  if (productData) {
    titleElement.textContent = productData.title;
    
    // Determine if this is a bike or treadmill comparison
    const dropdown = document.querySelector(`[data-column-id="${columnId}"]`);
    const dropdownCategory = dropdown?.dataset.productCategory || 'treadmill';
    const isBike = dropdownCategory === 'bike' || productData.category === 'bike' || productHandle.includes('bike');
    
    // Build specifications HTML
    if (productData.specs && Object.keys(productData.specs).length > 0) {
      textContainer.innerHTML = isBike ? 
        buildBikeSpecsHtml(productData, columnId) : 
        buildTreadmillSpecsHtml(productData, columnId);
    } else {
      // Use fallback specifications if no loaded specs
      const fallbackSpecs = getFallbackSpecs(productHandle, isBike);
      if (fallbackSpecs) {
        const fallbackData = { ...productData, specs: fallbackSpecs };
        textContainer.innerHTML = isBike ? 
          buildBikeSpecsHtml(fallbackData, columnId) : 
          buildTreadmillSpecsHtml(fallbackData, columnId);
      } else {
        textContainer.innerHTML = isBike ? 
          '<p>Bike specifications will be displayed here.</p>' : 
          '<p>Treadmill specifications will be displayed here.</p>';
      }
    }
    
    // Update price display
    updateProductPrice(comparisonCard, optionElement);
    
    // Update image if needed
    if (productData.image && (!optionElement.dataset.image || optionElement.dataset.image === 'null')) {
      const imageContainer = comparisonCard.querySelector('.compare-models-card__image img');
      if (imageContainer) {
        imageContainer.src = productData.image;
        imageContainer.alt = productData.title;
        
        const baseUrl = productData.image.split('?')[0];
        imageContainer.srcset = `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=535 535w, ${baseUrl}?width=750 750w, ${baseUrl}?width=940 940w, ${baseUrl}?width=1100 1100w`;
      }
    }
  } else {
    // No product data found - show basic info
    titleElement.textContent = optionElement.textContent.trim();
    const dropdown = document.querySelector(`[data-column-id="${columnId}"]`);
    const dropdownCategory = dropdown?.dataset.productCategory || 'treadmill';
    const isBike = dropdownCategory === 'bike' || productHandle.includes('bike');
    
    textContainer.innerHTML = isBike ? 
      '<p>Bike specifications will be displayed here.</p>' : 
      '<p>Treadmill specifications will be displayed here.</p>';
  }
}

function getFallbackSpecs(productHandle, isBike) {
  // No hardcoded fallbacks - only use metafield data
  return null;
}

function buildTreadmillSpecsHtml(productData, columnId) {
  let specsHtml = '';
  const specs = productData.specs;
  
  function getSpecText(value) {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object' && value.value) return String(value.value).trim();
    return String(value).trim();
  }

  const treadmillSpecs = [
    { key: 'frame', label: 'Frame' },
    { key: 'training_features', label: 'Training Features' },
    { key: 'programs', label: 'Programs' },
    { key: 'technology', label: 'Technology' },
    { key: 'warranty', label: 'Warranty' }
  ];
  
  // Only show headings on the left side (column 1)
  const showHeadings = columnId === '1';
  
  treadmillSpecs.forEach(spec => {
    const value = specs[spec.key] || specs[`${spec.key}_individual`];
    const text = getSpecText(value);
    
    if (text) {
      if (showHeadings) {
        // Left side: show actual headings with inline bold styling
        specsHtml += `<h6 style="font-weight: 900 !important; color: #1a1a1a !important; text-shadow: 0 0 1px rgba(0,0,0,0.5) !important;">${spec.label}</h6><p class="spec-${spec.key}">${text}</p>`;
      } else {
        // Right side: show blank/invisible heading to maintain alignment
        specsHtml += `<h6 style="visibility: hidden; font-weight: 700 !important;">&nbsp;</h6><p class="spec-${spec.key}">${text}</p>`;
      }
    }
  });
  
  return specsHtml || '<p>Treadmill specifications will be displayed here.</p>';
}

function buildBikeSpecsHtml(productData, columnId) {
  let specsHtml = '';
  const specs = productData.specs;
  
  function getSpecText(value) {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object' && value.value) return String(value.value).trim();
    return String(value).trim();
  }

  const bikeSpecs = [
    { key: 'frame', label: 'Frame' },
    { key: 'adjustability', label: 'Adjustability' },
    { key: 'programs', label: 'Programs' },
    { key: 'technology', label: 'Technology' },
    { key: 'warranty', label: 'Warranty' }
  ];
  
  // Only show headings on the left side (column 1)
  const showHeadings = columnId === '1';
  
  bikeSpecs.forEach(spec => {
    let value = specs[spec.key] || specs[`${spec.key}_individual`];
    
    // Special handling for warranty - check both warranty and best_in_class_warranty
    if (spec.key === 'warranty' && !value) {
      value = specs['best_in_class_warranty'];
    }
    
    const text = getSpecText(value);
    
    if (text) {
      if (showHeadings) {
        // Left side: show actual headings with inline bold styling
        specsHtml += `<h6 style="font-weight: 900 !important; color: #1a1a1a !important; text-shadow: 0 0 1px rgba(0,0,0,0.5) !important;">${spec.label}</h6><p class="spec-${spec.key}">${text}</p>`;
      } else {
        // Right side: show blank/invisible heading to maintain alignment
        specsHtml += `<h6 style="visibility: hidden; font-weight: 700 !important;">&nbsp;</h6><p class="spec-${spec.key}">${text}</p>`;
      }
    }
  });
  
  return specsHtml || '<p>Bike specifications will be displayed here.</p>';
}

// SessionStorage functions for browser navigation state
function saveDropdownState() {
  const state = {};
  const dropdowns = document.querySelectorAll('.compare-models-dropdown');
  
  dropdowns.forEach(dropdown => {
    const columnId = dropdown.dataset.columnId;
    const selectedOption = dropdown.querySelector('.dropdown-option--selected');
    
    if (columnId && selectedOption) {
      state[columnId] = selectedOption.dataset.value;
    }
  });
  
  try {
    sessionStorage.setItem('product-comparison-state', JSON.stringify(state));
  } catch (e) {
    console.error('Failed to save product comparison state:', e);
  }
}

function restoreDropdownState() {
  // Only restore if this is browser navigation (back/forward)
  // Check multiple indicators for browser navigation
  const perfEntries = performance.getEntriesByType('navigation');
  const isBackForward = perfEntries.length > 0 && perfEntries[0].type === 'back_forward';
  
  // Fallback for older browsers
  const isNavigation = performance.navigation && performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD;
  
  // Only restore state if this is browser navigation
  if (!isBackForward && !isNavigation) {
    try {
      sessionStorage.removeItem('product-comparison-state');
    } catch (e) {
      console.error('Failed to remove product comparison state:', e);
    }
    return;
  }
  
  try {
    const stateStr = sessionStorage.getItem('product-comparison-state');
    if (!stateStr) {
      return;
    }
    
    const state = JSON.parse(stateStr);
    
    Object.keys(state).forEach(columnId => {
      const dropdown = document.querySelector(`[data-column-id="${columnId}"]`);
      if (!dropdown) return;
      
      const targetOption = dropdown.querySelector(`[data-value="${state[columnId]}"]`);
      if (!targetOption) return;
      
      // Update dropdown selection
      const allOptions = dropdown.querySelectorAll('.dropdown-option');
      allOptions.forEach(opt => opt.classList.remove('dropdown-option--selected'));
      targetOption.classList.add('dropdown-option--selected');
      
      // Update button text
      const buttonText = dropdown.querySelector('.dropdown-button-text');
      const input = dropdown.querySelector('.dropdown-input');
      if (buttonText) buttonText.textContent = targetOption.textContent.trim();
      if (input) input.value = targetOption.dataset.value;
      
      // Update comparison content
      updateProductComparison(targetOption, columnId);
    });
  } catch (e) {
    console.error('Failed to restore product comparison state:', e);
  }
}

// Save state when user makes selections
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('dropdown-option')) {
    // Small delay to ensure UI is updated before saving
    setTimeout(saveDropdownState, 100);
  }
});

// Save state before page unload (for navigation)
window.addEventListener('beforeunload', saveDropdownState);

// Initialize default comparison content
function initializeDefaultContent() {
  const dropdowns = document.querySelectorAll('.compare-models-dropdown[data-initialized="true"]');
  
  dropdowns.forEach(dropdown => {
    const columnId = dropdown.dataset.columnId;
    const selectedOption = dropdown.querySelector('.dropdown-option--selected');
    
    if (selectedOption && columnId) {
      updateProductComparison(selectedOption, columnId);
    }
  });
}

// Trigger initialization after a brief delay to ensure DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initializeDefaultContent, 500);
});

function updateProductPrice(comparisonCard, optionElement) {
  const priceContainer = comparisonCard.querySelector('.compare-models-card__price .f-price') || 
                        comparisonCard.querySelector('.compare-models-card__price') ||
                        comparisonCard.querySelector('.f-price');
  
  if (!priceContainer || !optionElement.dataset.price) {
    return;
  }
  
  // Get the price values - ensure we parse correctly
  const priceValue = parseFloat(optionElement.dataset.price);
  const compareAtPriceRaw = optionElement.getAttribute('data-compare-at-price');
  let compareAtPriceValue = null;
  
  // Only consider compare-at price if it exists and is greater than 0
  if (compareAtPriceRaw && compareAtPriceRaw !== '' && compareAtPriceRaw !== '0' && compareAtPriceRaw !== '0.00') {
    compareAtPriceValue = parseFloat(compareAtPriceRaw);
  }
  
  // Validate price values
  if (isNaN(priceValue) || priceValue <= 0) {
    return;
  }
  
  // Format prices using USD currency
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(priceValue);
  
  let formattedCompareAtPrice = null;
  const isOnSale = compareAtPriceValue && compareAtPriceValue > priceValue;
  
  if (isOnSale) {
    formattedCompareAtPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(compareAtPriceValue);
  }
  
  // Find or create the f-price element
  let fPriceElement = priceContainer.classList.contains('f-price') ? priceContainer : priceContainer.querySelector('.f-price');
  
  if (!fPriceElement) {
    fPriceElement = document.createElement('div');
    fPriceElement.className = 'f-price';
    priceContainer.appendChild(fPriceElement);
  }
  
  if (fPriceElement) {
    if (isOnSale) {
      // Sale price structure - show sale price first, then strikethrough regular price
      fPriceElement.innerHTML = `
        <div class="f-price__sale">
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="f-price-item f-price-item--sale">${formattedPrice}</span>
        </div>
        <div class="f-price__regular">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="f-price-item f-price-item--regular">
            <s>${formattedCompareAtPrice}</s>
          </span>
        </div>
      `;
      fPriceElement.classList.add('f-price--on-sale');
    } else {
      // Regular price only structure
      fPriceElement.innerHTML = `
        <div class="f-price__regular">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
          <span class="f-price-item f-price-item--regular">${formattedPrice}</span>
        </div>
      `;
      fPriceElement.classList.remove('f-price--on-sale');
    }
  }
}